import { ProfileActions } from 'src/components/Profile/reducer';
import type { Action } from 'src/types';

interface State {
  authenticationStatus: 'pending' | 'authenticated' | 'unauthenticated';
}

const initialState: State = {
  authenticationStatus: 'pending',
};

type UserAction =
  | Action<ProfileActions.PROFILE_LOADED>
  | Action<ProfileActions.PROFILE_NOT_AUTHENTICATED>;

export const userReducer = (
  state: State = initialState,
  action: UserAction,
): State => {
  switch (action.type) {
    case ProfileActions.PROFILE_LOADED: {
      return {
        ...state,
        authenticationStatus: 'authenticated',
      };
    }

    case ProfileActions.PROFILE_NOT_AUTHENTICATED: {
      return {
        ...state,
        authenticationStatus: 'unauthenticated',
      };
    }

    default:
      return state;
  }
};
